import { getCurrentFieldIdFromNew } from "../workspace";

export const listDefection = async (apiClient, filters) => {
    try {
        const params = {};
        if (filters) {
            if (filters.defection_seq) params.defectionSeq = filters.defection_seq;
            if (filters.leaf_seq) params.leafSeq = filters.leaf_seq;
            if (filters.turbine_name) params.turbineName = filters.turbine_name;
            if (filters.defection_type) params.defectionType = filters.defection_type;
            if (filters.defection_part) params.defectionPart = filters.defection_part;
            if (filters.field_name) params.fieldName = filters.field_name;
            if (filters.check_at) params.checkAt = filters.check_at;
            if (filters.session_status) params.sessionStatus = filters.session_status;
        }
        // Get current field from workspace context
        let fieldId = getCurrentFieldIdFromNew();
        if (fieldId) {
            // Extract numeric ID if it's in SurrealDB format (e.g., "field_item:1" -> "1")
            if (typeof fieldId === 'string' && fieldId.includes(':')) {
                fieldId = fieldId.split(':')[1];
            }
            params.fieldId = fieldId;
        }
        const defections = await apiClient.getDefectionsList(params);

        // Client-side filtering by session status if backend doesn't support it yet
        let filteredDefections = defections || [];
        if (filters?.session_status) {
            filteredDefections = filteredDefections.filter(item => {
                const sessionStatus = item.from_frame?.from_raw?.task?.session?.ReviewStatus;
                if (filters.session_status === 'completed') {
                    return !sessionStatus || sessionStatus === 'completed';
                } else {
                    return sessionStatus === filters.session_status;
                }
            });
        }

        return filteredDefections;
    } catch (error) {
        console.error("Failed to load defections:", error);
        if (error.message && error.message.includes('404')) {
            console.warn("DefectionController API endpoint not available. Backend may need restart to load new controller.");
        }
        return [];
    }
};

export const listDefectionOfTask = async (apiClient, taskId) => {
    try {
        const defections = await apiClient.getDefectionsByTask(taskId);
        return defections || [];
    } catch (error) {
        console.error("Failed to load defections for task:", error);
        return [];
    }
};
